import { SETTINGSSTATE, THROTTLE_TIMERS } from '..'
import { ThrottleTimers, TimerType } from '../../../types/state'
import { loadUserIfNeeded } from '../../actions/loadUserIfNeeded'
import { SnapSize, TimerEvent } from '../../constants/enums'
import { previewSnapshotUrl } from '../../mfcLogic/avatarPreviewUrl'
import { getTimeoutFromAnimationUeopt } from '../../mfcLogic/settings'
import { randomize } from '../../utilities/math'
import { getStateUser, getUsersState } from '../getState'
import { pubSubTimer } from '../pubSub'
import { isCallbacksEmpty } from '../pubSub/createPubSub'

export const registerTimer = (
    key: keyof ThrottleTimers['timers'],
    callback: () => any,
    delay: number,
    type: TimerType = 'interval',
) => {
    // console.log(
    //     `[registerTimer] registering timer`,
    //     { key, delay, timer: THROTTLE_TIMERS.timers[key]?.id, type },
    //     THROTTLE_TIMERS,
    // )
    unregisterTimer(key) // clear any existing timer

    const timerFn = type === 'timeout' ? setTimeout : setInterval
    THROTTLE_TIMERS.timers[key] = {
        id: timerFn(() => {
            if (THROTTLE_TIMERS.paused) return
            // console.log(`* timer running *`, {
            //     key,
            //     delay,
            //     timer: THROTTLE_TIMERS.timers[key]?.id,
            //     type,
            // })
            callback()
        }, delay),
        type,
    }
}

export const unregisterTimer = (key: keyof ThrottleTimers['timers']) => {
    const entry = THROTTLE_TIMERS.timers[key]
    if (!entry) return
    if (entry.type === 'timeout') clearTimeout(entry.id)
    else clearInterval(entry.id)
    THROTTLE_TIMERS.timers[key] = null
}

// export const registerRafTimer = (
//     key: keyof ThrottleTimers['timers'],
//     callback: () => any,
// ) => {
//     cancelAnimationFrame(THROTTLE_TIMERS.timers[key] as number)
//     const rafCallback = () => {
//         cancelAnimationFrame(THROTTLE_TIMERS.timers[key] as number)
//         THROTTLE_TIMERS.timers[key] = requestAnimationFrame(rafCallback)
//         if (THROTTLE_TIMERS.paused) return
//         // console.log('[registerRafTimer] calling callback', callback)
//         callback()
//     }
//     THROTTLE_TIMERS.timers[key] = requestAnimationFrame(rafCallback)
// }

// export const unregisterRafTimer = (key: keyof ThrottleTimers['timers']) => {
//     cancelAnimationFrame(THROTTLE_TIMERS.timers[key] as number)
//     THROTTLE_TIMERS.timers[key] = null
// }

const SNAPS_PER_CYCLE = 40
// For a due entry with no pubsub subscribers: the subbed flag is a
// one-sweep grace for a remount, so the first such sweep spends it and
// the second deletes the entry
const deleteAfterGrace = (snapKey: string, posterTimer) => {
    if (!posterTimer.subbed) delete THROTTLE_TIMERS.snaps[snapKey]
    else posterTimer.subbed = false
}
/** One pass of the snapshot sweep; the interval below runs it every 500 ms */
export const processSnaps = async () => {
    // TODO: this should be able to better limit the updates to
    // x amount in some defined time span
    const now = Date.now()

    let counter = 0
    const snapKeys = Object.keys(THROTTLE_TIMERS.snaps)
    const animationSpeed = getTimeoutFromAnimationUeopt(
        SETTINGSSTATE.DEFAULT.animationSpeed,
    )

    for (const snapKey of snapKeys) {
        const posterTimer = THROTTLE_TIMERS.snaps[snapKey]
        if (!posterTimer) continue

        // if we have some that aren't processed yet then just do them
        if (counter >= SNAPS_PER_CYCLE && posterTimer.timestamp !== 0) return

        // Checked on every sweep, not only due ones, so a remount within
        // a throttle period gets its grace back
        const eventKey = `${TimerEvent.STATE}::${snapKey}`
        let subscribed = !isCallbacksEmpty('TIMER_', eventKey)
        if (subscribed) posterTimer.subbed = true

        if (now - posterTimer.timestamp > posterTimer.throttle) {
            if (posterTimer.staticImage) {
                // while we're static just keep kicking the can down the
                // road; no fetch, so it does not count against the cycle
                posterTimer.timestamp = now
                if (!subscribed) deleteAfterGrace(snapKey, posterTimer)
                continue
            }
            counter++
            // console.log('[snap loop]', snapKey, idToSlug[snapKey], {
            //     ...posterTimer,
            // })
            const snapKeyId = Number(snapKey)
            // const user = getStateUser(snapKeyId)
            if (!getStateUser(snapKeyId)) {
                await loadUserIfNeeded(snapKeyId)
                // a poster can mount during the await
                subscribed = !isCallbacksEmpty('TIMER_', eventKey)
                if (subscribed) posterTimer.subbed = true
            }

            posterTimer.timestamp = now

            // recalc the throttle to ensure we update when a user changes their setting
            posterTimer.throttle = Math.max(
                animationSpeed + randomize(-500, 500),
                1000,
            )

            // create a new srcUrl
            posterTimer.srcUrl = previewSnapshotUrl(snapKeyId, {
                large: posterTimer.size === SnapSize.large,
                xsmall: posterTimer.size === SnapSize.small,
            })
            if (subscribed) {
                const newPosterTimer = { ...posterTimer }
                THROTTLE_TIMERS.snaps[snapKey] = newPosterTimer
                pubSubTimer.emit(eventKey, newPosterTimer, true)
            } else {
                deleteAfterGrace(snapKey, posterTimer)
            }
        }
    }
}

if (typeof window !== 'undefined') {
    // this should check and update the src urls for any
    // active snaps we have subscribed based on their throttles
    registerTimer(
        'snaps',
        () => {
            const usersState = getUsersState()
            if (!usersState || !usersState.modelsLoaded) return
            void processSnaps()
        },
        500,
    )
}
